<div class="qt-chat" (click)="onChatAreaClick($event)">
  <div class="qt-chat__header sr-only" aria-live="polite">
    {{ 'GNR_AI_CHAT' | translate }}
  </div>

  @if (allMessages().length === 0 && !isTyping()) {
    <div class="qt-chat__empty">
      {{ 'GNR_AI_CHAT_HELP' | translate }}
    </div>
  }

  <div class="qt-chat__scroll chat-body-inner" #scroll>
    @for (m of allMessages(); track m.id; let i = $index) {
      <qt-ai-chat-enhanced-message-bubble
        [message]="m"
        [previousMessageText]="getPreviousMessageText(i)">
      </qt-ai-chat-enhanced-message-bubble>
    }

    @if (isTyping()) {
      <qt-ai-chat-enhanced-message-bubble
        [isTyping]="true"
        [typingDots]="typingDots"
        [message]="typingMessage"
        [typingLottieSrc]="typingLottieSrc()"
        [typingLottieSize]="typingLottieSize()">
      </qt-ai-chat-enhanced-message-bubble>
    }
  </div>

  <div
    #inputArea
    class="qt-chat__input chat-input-area"
    [class.qt-chat__input--dragging]="isDropActive()"
    (dragenter)="onDragEnter($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    @if (isDropActive()) {
      <div class="qt-chat__dropzone" aria-hidden="true">
        <mat-icon>cloud_upload</mat-icon>
        <span>{{ 'GNR_DROP_FILES_UPLOAD' | translate }}</span>
      </div>
    }

    @if (attachmentFormatError(); as errorMessage) {
      <div class="qt-chat__format-error" role="alert">
        {{ errorMessage }}
      </div>
    }

    @if (attachedFiles().length || pendingFilesForDisplay().length) {
      <div class="qt-chat__attachments" aria-label="Attached files">
        @for (f of attachedFiles(); track f.id) {
          <span class="qt-chat__attachment-chip">
            <span class="qt-chat__attachment-name">{{ f.name }}</span>
            <span class="qt-chat__attachment-type">{{
              fileTypeLabel(f.type)
            }}</span>
            <button
              type="button"
              class="qt-chat__attachment-remove"
              (click)="removeAttachedFile(f.id)"
              [attr.aria-label]="'GNR_REMOVE_ATTACHMENT' | translate">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        }
        @for (f of pendingFilesForDisplay(); track f.name) {
          <span
            class="qt-chat__attachment-chip qt-chat__attachment-chip--pending">
            <span class="qt-chat__attachment-name">{{ f.name }}</span>
            <span class="qt-chat__attachment-type">{{
              fileTypeLabel(f.type)
            }}</span>
            <button
              type="button"
              class="qt-chat__attachment-remove"
              (click)="removePendingFile(f.name)"
              [attr.aria-label]="'GNR_REMOVE_ATTACHMENT' | translate">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        }
      </div>
    }

    <div class="qt-chat__prompt input-wrapper">
      <input
        #filePicker
        id="qt-chat-file-picker"
        type="file"
        hidden
        multiple
        (change)="onFilesSelected($event)"
        [attr.accept]="allowedAttachmentAccept" />
      <button
        class="qt-attach attach-btn"
        type="button"
        (click)="openFilePicker()"
        [disabled]="!canAttach()"
        aria-label="Attach files">
        <mat-icon>attach_file</mat-icon>
      </button>
      <textarea
        #chatInput
        class="qt-input qt-input-field chat-input"
        rows="1"
        maxlength="4000"
        placeholder="{{ 'GNR_AI_CHAT_ASK' | translate }}..."
        aria-label="Ask anything"
        [ngModel]="draft()"
        (ngModelChange)="draft.set($event)"
        (input)="growChatInput()"
        (keydown.enter)="onChatKeydown($event)"></textarea>

      <button
        class="qt-send send-btn"
        type="button"
        (click)="send()"
        [disabled]="!canSend()"
        aria-label="Send">
        <svg
          class="qt-send__icon"
          viewBox="0 -960 960 960"
          width="24"
          height="24"
          fill="currentColor"
          aria-hidden="true">
          <path
            d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
        </svg>
      </button>
    </div>
  </div>
</div>
